export const PLAYER_RULES = {
  radius: 0.32,
  reviveRadius: 1.4,
  reviveSeconds: 3,
  bleedoutSeconds: 25,
  revivedHealthFraction: 0.35,
  respawnHealthFraction: 0.5,
} as const;
